import styled from 'styled-components';

export const OtpBlockWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
    `
);

export const OtpMainWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        padding-top: ${props.theme.spacing.large.l15};
        padding-bottom: ${props.theme.spacing.large.l15};
    `,
);

export const EyeWrapper = styled.div(
    props => `
      position: absolute;
      height: 42px;
      right: 0;
      top: 2rem;
      display: flex;
      aling-items: center;
      justidy-content: center;
      border-radius: 0 ${props.theme.misc.borderRadius.base} ${props.theme.misc.borderRadius.base} 0;
    `
);

export const PasswordBlockWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        margin: 2rem 0;
        justify-content: space-between;
    `
);

export const PasswordClickWrap = styled.div(
    props => `
        display: flex;
    `
);

export const PasswordText = styled.a(
    props => `
        text-decoration: none;
        font-size:1.6rem;
        color: #0091ff;
        font-weight: 900;
        cursor: pointer;
    `
);

export const PasswordResetWrap = styled.div(
    props => `
        display: flex;
        justify-content: flex-end;
    `
);

export const PasswordReset = styled.a(
    props => `
        text-decoration: none;
        font-size:1.6rem;
        color: #0091ff;
        font-weight: 900;
        cursor: pointer;
    `
);

export const ForgotPasswordLoaderContainer = styled.div(
    props => `
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        width: 86%;
        margin-top: 5px;
    `
);

export const ForgotPasswordBlock = styled.div(
    props => `
        width:100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-right: ${props.theme.spacing.small.s4};
  
        @media only screen and (min-width:320px) and (max-width: 768px){
            padding-top: 0rem;
            justify-content: flex-end;
        }
  
        @media only screen and (min-width:1025px) and (max-width: 1300px){
            justify-content: flex-end;
        }
    `,
);

export const ForgotPasswordBlockText = styled.a(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.blue.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        cursor: pointer;
    `,
)